export const ALL_CONTINENTS = {
  id: '',
  text: 'All Continents',
  isPermitted: true,
};
